const translations = {
  'about.seo.title': 'La Historia de TEFL Iberia',
  'about.seo.description':
    'Conoce cómo comenzamos con los cursos TEFL en España y nos convertimos en uno de los mejores proveedores del país organizando cursos en Barcelona y Sevilla.',
  'about.sec1.title': 'La Historia de TEFL Iberia',
  'about.sec2.title': 'Cómo empezamos',
  'about.sec2.description':
    'En el verano de 2008, Richard Davie se graduó de la Universidad de Edimburgo y se mudó a Barcelona en busca de aventuras y nuevas experiencias. Después de varios trabajos como profesor/a de inglés y cursos de formación de profesores en varias academias, tenía una clara idea de lo que funcionaba y lo que no funcionaba en las escuelas de idiomas. Quería ofrecer una formación de calidad en grupos reducidos, donde los estudiantes pudieran sentirse como en casa.',
  'about.sec2.text1':
    'Encontró la ubicación perfecta en Languages4Life, sin duda la academia de idiomas más moderna de España. Aulas cómodas, pizarras interactivas, una hermosa biblioteca, ordenadores MAC actualizados la convierten en el hogar perfecto para TEFL Iberia.',
  'about.sec2.text2':
    'Y así nació TEFL Iberia en 2012, desde entonces ha ido de éxito en éxito, atrayendo a personas de todas las edades y procedencias para formarse como profesores y encontrar trabajo en Barcelona.',

  'about.sec3.title': 'Lo que hacemos:',
  'about.sec3.description':
    'Queremos ayudarte a seguir el mismo camino que Richard tomó cuando era un joven de 23 años y brindarte todo lo que necesitas para establecerte:',
  'about.sec3.ben1.title': 'Un trabajo gratificante',
  'about.sec3.ben1.text':
    'Encontrarás trabajo rápidamente con nuestra asesoría experta y nuestra red local de contactos escolares.',
  'about.sec3.ben2.title': 'Un alojamiento cómodo',
  'about.sec3.ben2.text':
    'Ubicado en el centro de la ciudad con compañeros de piso similares a ti. ',
  'about.sec3.ben3.title': 'Una red de amigos',
  'about.sec3.ben3.text':
    'Serás amigos de por vida con tus compañeros de clase y tendrás acceso a nuestra red de graduados más grande.',
  'about.sec3.ben4.title': 'Burocracia española',
  'about.sec3.ben4.text':
    'Visas, papeleo, NIE, número de seguridad social, cuenta bancaria. ¡Podemos facilitarte estos procesos!',

  'about.sec3.text1':
    'La escuela ha sido un gran éxito y ahora se encuentra entre los mejores cursos de TEFL del mundo, según <accentedLink> TEFL course review </accentedLink>. Richard también ha trabajado con varias publicaciones universitarias y estudiantiles importantes, promoviendo TEFL y trabajando en el extranjero.',
  'about.sec3.text2':
    'En 2017, el equipo tomó la gran decisión de obtener la acreditación de Trinity College London y convertirse en un proveedor de Trinity CertTESOL. La combinación de la ética de una pequeña escuela y un enfoque personalizado con una calificación reconocida a nivel mundial ha convertido a TEFL Iberia en una de las escuelas más solicitadas del mundo. Cumplimos estrictamente con 12 plazas por grupo para garantizar la mejor formación y experiencia posible.',

  'about.sec4.title': 'Cómo lo hacemos',
  'about.sec4.description':
    'Hemos formado a cientos de nuevos profesores y todos tienen cosas excelentes que decir sobre la escuela. Seguramente mencionarán:',
  'about.sec4.ben1': 'Grupos pequeños (máximo 12, no 20).',
  'about.sec4.ben2':
    'Práctica de enseñanza variada con estudiantes reales (grupos grandes y pequeños, niveles de principiante a avanzado).',
  'about.sec4.ben3': 'Excelente apoyo de nuestro personal.',
  'about.sec4.ben4': 'Inculcarles la confianza para enseñar.',
  'about.sec4.ben5':
    'Las excelentes oportunidades de trabajo disponibles para ellos después (trabajamos muy duro para hacer de TEFL Iberia una de las marcas de TEFL más conocidas).',
  'about.sec4.ben6': 'Una calificación reconocida internacionalmente.',

  'about.sec5.title': '¿Listo para comenzar tu <accent> aventura en el extranjero?</accent>',
  'about.sec5.btn': `Vamos`,
};

export default translations;
